/**
 * Aggregates for table footers (Clients / Fournisseurs) — aligns with Archives partner matching.
 */
import { formatBrandMoney } from '../../../shared/utils/brandCurrency';

function norm(s) {
  return (s || '').toString().trim().toLowerCase();
}

/** Formatted monetary total for list footers (SAR / legacy brand currency). */
export function fmtFooterDa(value) {
  return formatBrandMoney(value);
}

function partnerNameVariants(partner) {
  const raw = partner?.company_name || partner?.name || '';
  return new Set([norm(raw), norm(partner?.company_name), norm(partner?.name)].filter(Boolean));
}

function documentMatchesPartner(doc, partner, { supplierMode }) {
  const pid = partner?.id != null ? String(partner.id) : '';

  const idFields = supplierMode
    ? [doc.supplier_id, doc.supplierId, doc.clientId]
    : [doc.client_id, doc.clientId];

  for (const f of idFields) {
    if (f != null && String(f) === pid) return true;
  }

  const docNames = new Set([
    norm(doc.client),
    norm(doc.client_name),
    norm(doc.client_nom),
    norm(doc.supplier_name),
    norm(doc.supplier)
  ].filter(Boolean));

  for (const vn of partnerNameVariants(partner)) {
    if (vn && docNames.has(vn)) return true;
  }
  return false;
}

/** Sales invoices only (clients), excluding drafts and supplier flows. */
function isSalesInvoice(doc) {
  if (!doc || doc.status === 'draft') return false;
  const t = String(doc.type || '').toLowerCase();
  if (doc.isSupplier === true) return false;
  if (t.includes('purchase') || t.includes('quote-request')) return false;
  return t === 'invoice' || t === 'facture';
}

/** Purchase / supplier-linked documents */
function isSupplierSpendDoc(doc) {
  if (!doc || doc.status === 'draft') return false;
  const t = String(doc.type || '').toLowerCase();
  if (doc.isSupplier === true) return true;
  if (t.includes('purchase')) return true;
  if (t === 'stock-entry' || t === 'supplier_invoice') return true;
  return false;
}

export function totalsForFilteredClients(filteredClients, documents) {
  let nbDocs = 0;
  let ca = 0;
  const ds = documents || [];
  const list = filteredClients || [];
  for (const doc of ds) {
    if (!isSalesInvoice(doc)) continue;
    if (!list.some((c) => documentMatchesPartner(doc, c, { supplierMode: false }))) continue;
    nbDocs += 1;
    ca += Number(doc.amount) || 0;
  }
  return { nbDocs, caTotal: ca };
}

export function totalsForFilteredSuppliers(filteredSuppliers, documents) {
  let nbDocs = 0;
  let montant = 0;
  const ds = documents || [];
  const list = filteredSuppliers || [];
  for (const doc of ds) {
    if (!isSupplierSpendDoc(doc)) continue;
    if (!list.some((s) => documentMatchesPartner(doc, s, { supplierMode: true }))) continue;
    nbDocs += 1;
    montant += Number(doc.amount) || 0;
  }
  return { nbDocs, totalMontant: montant };
}

